import {
    TOGGLE_AREA_EXECUTIVE_STATUS_SUCCESS,
    TOGGLE_AREA_EXECUTIVE_STATUS_FAILURE
} from '../actions/types';

const initialState = {
    areaExecutiveList: [],
    loading: false,
    error: null,
};

export const areaExecutiveToggleStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_AREA_EXECUTIVE_STATUS_SUCCESS: {
            const updatedAreaExecutiveList = state?.areaExecutiveList?.results?.map((areaExecutive) =>
                areaExecutive.id === action.payload.areaExecutiveId
                    ? { ...areaExecutive, is_active: action.payload.isActive }
                    : areaExecutive
            );
            return {
                ...state,
                areaExecutiveList: {
                    ...state.areaExecutiveList,
                    results: updatedAreaExecutiveList,
                },
            };
        }
        case TOGGLE_AREA_EXECUTIVE_STATUS_FAILURE:
            return {
                ...state,
                error: action.payload.error,
            };
        default:
            return state;
    }
};
